import React from 'react';
import PropTypes from 'prop-types';
import DrawerApp from './drawer-app';
import SelectWinnerDrawer from './select-winner-drawer';
import SelectWinnerFullscreenDrawer from './select-winner-fullscreen-drawer';
import DrawerPlaceholder from './drawer-placeholder';

class SelectWinnerDrawerApp extends React.Component {
    constructor() {
        super();
        this.state = {
            entriesNeedingPopup: [],
        };

        this.confirmationPopupTimer;
        this.confirmationPopupTiming = 1500;
    }

    handleConfirmationPopup(oldWinners, newWinners) {
        const entriesNeedingPopup = newWinners.filter(el => {
            return oldWinners.indexOf(el) < 0 ? el : null;
        });

        if (this.confirmationPopupTimer) {
            clearTimeout(this.confirmationPopupTimer);
        }

        this.setState({ entriesNeedingPopup }, () => {
            this.confirmationPopupTimer = setTimeout(() => {
                this.setState({ entriesNeedingPopup: [] });
            }, this.confirmationPopupTiming);
        });
    }

    UNSAFE_componentWillUpdate(nextProps) {
        if (this.props.entries.length < nextProps.entries.length) {
            this.handleConfirmationPopup(this.props.entries, nextProps.entries);
        }
    }

    render() {
        const { isDrawerVisible, onShowDrawer } = this.props;
        if (isDrawerVisible) {
            return (
                <DrawerApp
                    entriesNeedingPopup={this.state.entriesNeedingPopup}
                    drawer={SelectWinnerDrawer}
                    fullscreenDrawer={SelectWinnerFullscreenDrawer}
                    {...this.props}
                />
            );
        } else {
            return <DrawerPlaceholder onClick={onShowDrawer} />;
        }
    }
}

SelectWinnerDrawerApp.propTypes = {
    entries: PropTypes.array.isRequired,
    isDrawerVisible: PropTypes.bool.isRequired,
    onShowDrawer: PropTypes.func.isRequired,
};

export default SelectWinnerDrawerApp;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/select-winner-drawer-app.jsx